import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';

const LoadingByCheckIsExistTab = () => {
  const [progress, setProgress] = React.useState(1);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 99 ? prevProgress : prevProgress + 1));
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <WhiteBoxContent
      flexDirection={'column'}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      mt={3}
      height={750}
    >
      <Box mb={6} sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress thickness={10} size={250} value={progress} variant="determinate" />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h4" color={'primary.main'}>{`${Math.round(progress)}%`}</Typography>
        </Box>
      </Box>
      <Typography mb={1} color={'primary.main'} variant="h4">
        Generating Your Tailored Report
      </Typography>
      <Typography color={'text.secondary'} variant="subtitle1">
        Please wait about few seconds while we generate your customized report.
      </Typography>
    </WhiteBoxContent>
  );
};

export default LoadingByCheckIsExistTab;
